__turbopack_context__.v({
  "breadcrumbActiveLabel": "styles-module__0W3Voa__breadcrumbActiveLabel",
  "breadcrumbItem": "styles-module__0W3Voa__breadcrumbItem",
  "breadcrumbLabel": "styles-module__0W3Voa__breadcrumbLabel",
  "breadcrumbLink": "styles-module__0W3Voa__breadcrumbLink",
  "breadcrumbLinkText": "styles-module__0W3Voa__breadcrumbLinkText",
  "breadcrumbsContainer": "styles-module__0W3Voa__breadcrumbsContainer",
  "breadcrumbsList": "styles-module__0W3Voa__breadcrumbsList",
  "breadcrumbsScrollableContainer": "styles-module__0W3Voa__breadcrumbsScrollableContainer",
});
